import React from 'react';
import SettingPersonBlock from './components/SettingPersonBlock';

const Person = () => (
  <SettingPersonBlock />
);

export default Person;
